import axios from "axios";
import {DateFormatTypeEnum, GeneralResponseModel, ResponseBaseModel, ValidationErrorModel,} from "../models";
import {formatDateValue, getAppConfig, getUserToken} from "../utils";
//#region axios
// @ts-ignore
const AlYusrAxiosApiInstance = axios.create({
  // baseURL:
  //   process.env.REACT_APP_AlyusrApiEndpoint != null
  //     ? process.env.REACT_APP_AlyusrApiEndpoint.toString().trim()
  //     : "no-url",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  },
});
AlYusrAxiosApiInstance.interceptors.request.use(
  (config) => {
    config.baseURL =
      getAppConfig().apiEndPoint_Configurations.alyusrApiEndpoint;
    // @ts-ignore
    const token: string | null = getUserToken(); // CookieGet(process.env.REACT_APP_authenticatedTokenStorageKey);
    if (config.url?.includes("file/upload")) {
      // @ts-ignore
      config.headers["content-type"] = "multipart/form-data";
    } else {
      // @ts-ignore
      config.headers["content-type"] = "application/json";
      // @ts-ignore
      config.headers["accept-language"] = "en-US,en;q=0.9";
      // @ts-ignore
      config.headers["Accept"] = "application/json";
    }
    if (config.method === "post") {
      // @ts-ignore
      config.headers["Access-Control-Allow-Origin"] = "*";
    }
    if (token) {
      // @ts-ignore
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // if (config.data) {
    //   config.data = formatRequestDates(config.data); // 🕒 Automatically format all Date values
    // }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);
AlYusrAxiosApiInstance.interceptors.response.use(
  (response) => {
    // @ts-ignore
    return response.data;
  },
  (error) => {
    let result: ResponseBaseModel<GeneralResponseModel> = { Result: undefined };
    if (error.response) {
      if (error.response.status === 401) {
        result = {
          token: "",
          Result: {},
          Errors: [
            {
              MessageEn: "authorization failed please try to login",
              MessageAr: "فشل فى تسجيل الدخول الرجاء اعادة المحاولة مرة اخرى",
            },
          ],
        };
      } else if (error.response.status === 400) {
        const errors: ValidationErrorModel[] = [];
        if (error?.response?.data?.errors?.length !== 0) {
          error.response.data.errors.map((err: any) => {
            errors.push({
              MessageAr: err.errorMessage,
              MessageEn: err.errorMessage,
            });
          });
        } else {
        }
        result = {
          token: "",
          Result: {},
          Errors: errors,
        };
      } else if (error.message) {
        const message =
          error.errorMessage !== null && error.errorMessage !== undefined
            ? error.errorMessage
            : error.message;
        result = {
          Result: undefined,
          Errors: [{ MessageAr: message, MessageEn: message }],
        };
        return result;
      }
    } else {
      if (error.message) {
        const message =
          error.errorMessage !== null && error.errorMessage !== undefined
            ? error.errorMessage
            : error.message;
        result = {
          Result: {},
          token: "",
          Errors: [{ MessageAr: message, MessageEn: message }],
        };
        return result;
      } else if (error.request) {
        result = {
          token: "",
          Result: {},
          Errors: [
            {
              MessageEn: "error occurred  try again later",
              MessageAr: "حدث خطأ حاول مرة أخرى في وقت لاحق",
            },
          ],
        };
        //return  error.request.data;
      }
    }
    return result;
  }
);
//#endregion
//#region public
export const AxiosSearchParams = <T extends Record<string, any>>(
  arg: T,
  searchKey: string
): URLSearchParams =>
  Object.entries(arg).reduce((params, [key, value]) => {
    if (value != null) {
      params.append(
        `${searchKey}.${key}`,
        value instanceof Date ? formatDate(value) : String(value)
      );
    }
    return params;
  }, new URLSearchParams());
//#endregion
//#region private;
export  const formatDate = (date: Date | string | null | undefined) => {
  //return formatToIsoString(date);
  return formatDateValue(date,DateFormatTypeEnum.Iso_Date_Time)??"";
};


//#endregion
export default AlYusrAxiosApiInstance;
